






























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class MapPinIcon extends Vue {
  @Prop({ default: '12' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly fill?: string;
}
